import React, { useMemo, useState } from "react";
import { AppPage, MimaTable } from "../../../components";
import constant from "../../../utils/constant";
import moment from "moment";
import { amountFormatter } from "../../../utils/utils";
import { AnimatePresence } from "framer-motion";
import { ViewMoreUsersInfoContainer } from "../../../containers";

const MoneyExUsers = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  closeModal,
  moreInfoModal,
  setMoreInfoModal,
}) => {
  const [item, setItem] = useState({});

  const moneyExAdsTableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.moneyExUsers || [];
    }
    return [];
  }, [data]);

  const moneyExAdsTableColumns = [
    {
      Header: "User Name",
      Cell: ({ cell }) => {
        const userName = cell.row.original.username;
        return <span>{userName}</span>;
      },
    },
    {
      Header: "Personal Name",
      Cell: ({ cell }) => {
        const firstName = cell.row.original.firstname;
        const lastName = cell.row.original.lastname;
        const fullName = `${firstName} ${lastName}`;
        return <span>{fullName}</span>;
      },
    },
    {
      Header: "Mobile",
      accessor: "mobile",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Country",
      accessor: "country",
    },
    {
      Header: "Last Login Date",

      Cell: ({ cell }) => {
        const date = cell.row.original.lastLoginDate;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },

    {
      Header: "Status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const statusClass = `status ${
          status === "ACTIVE" ? "status__green" : "status__dark__yellow"
        }`;
        return <span className={statusClass}>{status}</span>;
      },
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setItem(item);
              setMoreInfoModal(true);
            }}
          >
            View More
          </span>
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Money-Ex Users">
      <MimaTable
        tableData={moneyExAdsTableData}
        tableColumns={moneyExAdsTableColumns}
        searchPlaceholder="Search Money-Ex Users"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
      {moreInfoModal && (
        <div className="modal">
          <AnimatePresence>
            {moreInfoModal && (
              <ViewMoreUsersInfoContainer closeModal={closeModal} item={item} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default MoneyExUsers;
